// Simple Excel export utility using SheetJS (xlsx)
// Install dependency in your project: yarn add xlsx

import * as XLSX from 'xlsx';

/**
 * Export an array of winner objects to an .xlsx file and trigger download.
 * @param {Array} rows - winner objects: { areaType, block, rowLabel, seatLabel, id }
 * @param {string} filename - e.g. '中奖结果.xlsx'
 * @param {Object} [meta] - optional metadata to prefix, e.g. { title, time }
 */
export function exportWinnersExcel(rows = [], filename = '中奖结果.xlsx', meta = {}) {
  const time = meta.time || new Date().toLocaleString();
  const title = meta.title || '中奖结果';

  // Map to 2D worksheet data
  const header = ['分区', '区块', '排', '座位', 'ID'];
  const data = rows.map(r => [
    r?.areaType ?? '',
    r?.block ?? '',
    r?.rowLabel ?? '',
    r?.seatLabel ?? '',
    r?.id ?? ''
  ]);

  const summary = [[title], ['导出时间', time], []];
  const sheetData = [...summary, header, ...data];

  const ws = XLSX.utils.aoa_to_sheet(sheetData);
  // Set column widths
  ws['!cols'] = [
    { wch: 10 }, // 分区
    { wch: 10 }, // 区块
    { wch: 8 },  // 排
    { wch: 8 },  // 座位
    { wch: 16 }, // ID
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Winners');

  XLSX.writeFile(wb, filename);
}
